"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var TravelAgent_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelAgent = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const graphql_1 = require("../graphql");
const orm_1 = require("../orm");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
let TravelAgent = TravelAgent_1 = class TravelAgent {
    constructor() {
        this.category = legacy_enums_1.TravelAgentCategory.DITA;
        this.currency = legacy_enums_1.Currency.Dollar;
        this.commissionPercentage = 0;
        this.createdAt = new Date();
        this.partnerBookingAvailable = false;
        this.tags = [];
    }
    get status() {
        return (0, statusGetter_1.statusGetter)(this, TravelAgent_1, legacy_enums_1.TravelAgentStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.TravelAgentStatus.Declined:
                return {
                    declinedAt: defined,
                };
            case legacy_enums_1.TravelAgentStatus.Approved:
                return {
                    declinedAt: undefined,
                    approvedAt: defined,
                };
            case legacy_enums_1.TravelAgentStatus.Pending:
            default:
                return {
                    declinedAt: undefined,
                    approvedAt: undefined,
                };
        }
    }
};
exports.TravelAgent = TravelAgent;
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.TravelAgentCategory),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(() => legacy_enums_1.TravelAgentCategory),
    __metadata("design:type", String)
], TravelAgent.prototype, "category", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(() => legacy_enums_1.Currency),
    __metadata("design:type", Number)
], TravelAgent.prototype, "currency", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    __metadata("design:type", Number)
], TravelAgent.prototype, "discountCoefficient", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    __metadata("design:type", Number)
], TravelAgent.prototype, "commissionPercentage", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgent.prototype, "approvedAt", void 0);
__decorate([
    (0, orm_1.CDCreateDateColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgent.prototype, "createdAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgent.prototype, "declinedAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (!value ? undefined : value)),
    __metadata("design:type", String)
], TravelAgent.prototype, "declinationReason", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    __metadata("design:type", String)
], TravelAgent.prototype, "agentId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)({ nullable: true }),
    __metadata("design:type", String)
], TravelAgent.prototype, "hostAgencyId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    __metadata("design:type", Boolean)
], TravelAgent.prototype, "partnerBookingAvailable", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (!value ? undefined : value)),
    __metadata("design:type", String)
], TravelAgent.prototype, "ownerId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], TravelAgent.prototype, "tags", void 0);
exports.TravelAgent = TravelAgent = TravelAgent_1 = __decorate([
    (0, class_transformer_1.Exclude)(),
    (0, graphql_1.GObjectType)("TravelAgent")
], TravelAgent);
//# sourceMappingURL=TravelAgent.js.map